<template>
    <AppMainFormCard :isLoading="isLoading" :tituloTela="tituloTela" :canDelete="isEditing" @delete="beforeDeleteRegistro" :canAdd="false"
        :isSearch="true" :canSearch="false">
        <v-form v-model="isFormValid" ref="form">
            <v-layout row wrap justify-center pl-2 pr-2 pb-3 pt-3 v-if="registro.idEntradaAnimais == ''">
                <v-flex lg11>
                    <h3>Selecione a origem</h3>
                </v-flex>
                <v-flex lg11>
                    <v-radio-group row v-model="cdSaidaAnimaisSelecionada">
                        <v-layout row wrap justify-center>
                            <v-flex pa-1 lg4 v-for="saida in listaSaidasDisponiveis" :key="saida.idSaidaAnimais">
                                <v-card hover :class="{colorOrange: cdSaidaAnimaisSelecionada == saida.idSaidaAnimais}" class="colorGray" 
                                    @click="changeSaida(saida.idSaidaAnimais)">
                                    <v-card-title style="padding-bottom: 1px;">
                                        <v-layout row align-center justify-start>
                                            <v-flex xs1 md2 lg1>
                                                <v-radio style="margin-right: -15px;" :value="saida.idSaidaAnimais"></v-radio>
                                            </v-flex>
                                            <v-flex xs10 md9 lg9 pl-2>
                                                <span class="subtitle-1">Estabelecimento: </span>
                                                <span class="title">{{ saida.loteProducao.jsonEstabelecimento.nmEstabelecimento }}</span>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-title>
                                    <v-card-text style="padding-top: 1px;">
                                        <v-layout row wrap align-center >
                                            <v-flex xs12 sm12 md12 lg12 align-center justify-start style="display: -webkit-box;">
                                                <span style="padding-right: 5px;">GTA: </span>
                                                <span>{{ saida.nrGta }} - {{ saida.dsSerieGta }}</span>
                                            </v-flex>
                                            <v-flex xs12 sm12 md12 lg12 align-center justify-start style="display: -webkit-box;">
                                                <span style="padding-right: 5px;">Data GTA: </span>
                                                <span>{{ dateIsoToLocal(saida.dtGta) }}</span>
                                            </v-flex>
                                            <v-flex xs12 sm12 md12 lg12 align-center justify-start style="display: -webkit-box;">
                                                <span style="padding-right: 5px;">Qtd Animais: </span>
                                                <span>{{ saida.qtAnimais }}</span>
                                            </v-flex>
                                            <v-flex xs12 sm12 md12 lg12 align-center justify-start style="display: -webkit-box;">
                                                <span style="padding-right: 5px;">UEP: </span>
                                                <span>{{ saida.loteProducao.jsonUnidadeExploracao.nrUnidadeExploracao }}</span>
                                            </v-flex>                                                    
                                            <v-flex xs12 sm12 md12 lg12 align-center justify-start style="display: -webkit-box;">
                                                <span style="padding-right: 5px;">Data Saída: </span>
                                                <span>{{ dateIsoToLocal(saida.dtSaida) }}</span>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <v-flex pa-1 lg3 style="display: flex;" v-if="listaSaidasDisponiveis.length > 0">
                                <v-card hover class="colorGray" :class="{colorOrange: cdSaidaAnimaisSelecionada == 0}"
                                    @click="changeSaida(0)">
                                    <v-card-title>
                                        <v-layout row wrap justify-center>
                                            <v-flex xs1 md2 lg2>
                                                <v-radio :value="0"></v-radio>
                                            </v-flex>
                                            <v-flex xs10 md9 lg9 pl-2>
                                                <span class="title">Não Rastreada</span>
                                            </v-flex>
                                        </v-layout>                                                
                                    </v-card-title>
                                    <v-card-text>
                                        <span>Informar os dados da origem manualmente</span>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <v-flex pa-1 lg6 style="display: flex;" v-else>
                                <v-card hover class="colorGray" :class="{colorOrange: cdSaidaAnimaisSelecionada == 0}"
                                    @click="changeSaida(0)">
                                    <v-card-title>
                                        <v-layout row wrap justify-center>
                                            <v-flex xs1 md2 lg2>
                                                <v-radio :value="0"></v-radio>
                                            </v-flex>
                                            <v-flex xs10 md9 lg9 pl-2>
                                                <span class="title">Não Rastreada</span>
                                            </v-flex>
                                        </v-layout>                                                
                                    </v-card-title>
                                    <v-card-text>
                                        <span>Informar os dados da origem manualmente</span>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-radio-group>
                </v-flex>
            </v-layout>
            <v-layout row justify-center v-if="!saidaSelecionada">
                <v-flex class="item" xs12 md11 mb-5>
                    <h3><b>Dados da Origem</b></h3>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-center v-if="!saidaSelecionada">
                <v-flex class="item" xs11 md11 lg11 v-if="registro.idEntradaAnimais != 0 && cdSaidaAnimaisSelecionada != 0">
                    <v-text-field v-model.trim="nmEstabelecimento" label="Estabelecimento" filled disabled>
                    </v-text-field>
                </v-flex>
                <v-flex class="item" xs11 md11 lg11 v-else>
                    <v-autocomplete :rules="[campoSelectObrigatorio]" v-model="registro.cdEstabelecimentoOrigem" :items="estabelecimentos" clearable
                        color="primary" item-text="displayName" item-value="idEstabelecimento" label="Selecione o estabelecimento por código oficial ou nome"
                        outlined>
                    </v-autocomplete>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-center v-if="!saidaSelecionada">
                <v-flex class="item" xs11 md11 lg11 v-if="registro.idEntradaAnimais != 0 && cdSaidaAnimaisSelecionada != 0">
                    <v-text-field v-model.trim="dsUnidadeExploracao" label="Unidade de Exploração" filled disabled>
                    </v-text-field>
                </v-flex>
                <v-flex class="item" xs11 md11 lg11 v-else>
                    <v-autocomplete :rules="[campoSelectObrigatorio]" v-model="registro.cdUnidadeExploracaoOrigem" :items="unidadesExploracao" clearable
                        color="primary" item-text="displayName" item-value="idUnidadeExploracao" label="Selecione a unidade exploração por número ou tipo"
                        outlined>
                    </v-autocomplete>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-center v-if="!saidaSelecionada">
                <v-flex class="item" xs12 md11 mb-5>
                    <h3><b>Dados da G.T.A</b></h3>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-center v-if="!saidaSelecionada">
                <v-flex class="item" xs11 md3 lg3 v-if="registro.idEntradaAnimais != 0 && cdSaidaAnimaisSelecionada != 0">
                    <v-text-field v-model.trim="registro.nrGta" label="Número" filled disabled>
                    </v-text-field>
                </v-flex>
                <v-flex class="item" xs11 md3 lg3 v-else>
                    <v-text-field :rules="[campoObrigatorio, campoMaiorZero]" v-mask="maskGta" v-model.number="registro.nrGta" type="tel" label="Número" 
                        outlined clearable>
                    </v-text-field>
                </v-flex>
                <v-flex class="item" xs11 md2 lg2 v-if="registro.idEntradaAnimais != 0 && cdSaidaAnimaisSelecionada != 0">
                    <v-text-field v-model.trim="registro.dsSerieGta" label="Série" filled disabled>
                    </v-text-field>
                </v-flex>
                <v-flex class="item" xs11 md2 lg2 v-else>
                    <v-text-field :rules="[campoObrigatorio]" v-mask="maskSerie" v-model.trim="registro.dsSerieGta" label="Série" 
                        outlined clearable>
                    </v-text-field>
                </v-flex>
                <v-flex class="item" xs11 md3 lg3 v-if="registro.idEntradaAnimais != 0 && cdSaidaAnimaisSelecionada != 0">
                    <v-text-field v-model.trim="dataGta" label="Data" filled disabled>
                    </v-text-field>
                </v-flex>
                <v-flex class="item" xs11 md3 lg3 v-else>
                    <SelectDate :rules="[campoObrigatorio, validarData]" label="Data" v-model="dataGta"></SelectDate>
                </v-flex>
                <v-flex class="item" xs11 md3 lg3 v-if="registro.idEntradaAnimais != 0 && cdSaidaAnimaisSelecionada != 0">
                    <v-text-field v-model.trim="registro.dsPlacaCaminhao" label="Placa do Caminhão" filled disabled>
                    </v-text-field>
                </v-flex>
                <v-flex class="item" xs11 md3 lg3 v-else>
                    <v-text-field :rules="[tamanhoMaximoOito]" v-model.trim="registro.dsPlacaCaminhao" label="Placa do Caminhão" 
                        outlined clearable>
                    </v-text-field>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-center>
                <v-flex class="item" xs12 md11 mb-5>
                    <h3><b>Dados do Alojamento</b></h3>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-center>
                <v-flex class="item" xs12 md6>
                    <SelectDate :rules="[campoObrigatorio, validarData]" label="Data" v-model="dataEntrada"></SelectDate>
                </v-flex>
                <v-flex class="item" xs12 md5>
                    <SelectHour :rules="[campoObrigatorio, validarHora]" label="Hora" v-model="registro.hrEntrada"></SelectHour>
                </v-flex>
            </v-layout>
            <v-layout row justify-center>
                <v-flex xs12 md3>
                    <v-text-field @change="calculaPeso('qtd')" :rules="regraCampoObrigatorioMacho" v-model.number="registro.qtMachos"
                        label="Qtd Machos" type="tel" v-mask="maskQtAnimais" outlined clearable
                        :disabled="sgSexoLote === 'FE'">
                    </v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                    <v-text-field @change="calculaPeso('qtd')" :rules="regraCampoObrigatorioFemea" v-model.number="registro.qtFemeas"
                        label="Qtd Fêmeas" type="tel" v-mask="maskQtAnimais" outlined clearable
                        :disabled="sgSexoLote === 'MA'">
                    </v-text-field>
                </v-flex>
                <v-flex xs12 md2>
                    <v-text-field @change="calculaPeso('nrPesoMedio')" type="number" v-model.number="registro.nrPesoMedio"
                        label="Peso médio(kg)" outlined clearable>
                    </v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                    <v-text-field @change="calculaPeso('nrPesoTotal')" v-model.number="registro.nrPesoTotal"
                        label="Peso total(kg)" type="number" outlined clearable>
                    </v-text-field>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-center>
                <v-flex class="item" xs12 md11 mb-5>
                    <h3><b>Divergência no alojamento</b></h3>
                </v-flex>
            </v-layout>
            <v-layout row class="ma-0 px-2">
                <v-flex xs12 sm12 md6 lg6 xl6>
                  <v-layout row class="ma-0 px-4">
                    <v-flex class="item" xs12 md11 mb-5>
                      <span class="body-1">Machos</span>
                    </v-flex>
                  </v-layout>
                  <v-layout row class="ma-0 px-4">
                    <v-flex xs6 class="pa-1">
                      <v-select
                        label="Tipo de divergência"
                        outlined
                        clearable
                        :items="divergenceTypes"
                        v-model="tipoDivergenciaMachos"
                        :filled="sgSexoLote === 'FE'"
                        :readonly="sgSexoLote === 'FE'"
                      />
                    </v-flex>
                    <v-flex xs6 class="pa-1">
                      <v-text-field
                        label="Quantidade de animais"
                        outlined
                        clearable
                        v-model="qtdDivergenciaMachos"
                        :filled="sgSexoLote === 'FE'"
                        :readonly="sgSexoLote === 'FE'"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm12 md6 lg6 xl6>
                  <v-layout row class="ma-0 px-4">
                    <v-flex class="item" xs12 md11 mb-5>
                      <span class="body-1">Fêmeas</span>
                    </v-flex>
                  </v-layout>
                  <v-layout row class="ma-0 px-4">
                    <v-flex xs6 class="pa-1">
                      <v-select
                        label="Tipo de divergência"
                        outlined
                        clearable
                        :items="divergenceTypes"
                        v-model="tipoDivergenciaFemeas"
                        :filled="sgSexoLote === 'MA'"
                        :readonly="sgSexoLote === 'MA'"
                      />
                    </v-flex>
                    <v-flex xs6 class="pa-1">
                      <v-text-field
                        label="Quantidade de animais"
                        outlined
                        clearable
                        v-model="qtdDivergenciaFemeas"
                        :filled="sgSexoLote === 'MA'"
                        :readonly="sgSexoLote === 'MA'"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
            </v-layout>
             <v-layout row wrap justify-center>
                <v-flex class="item" xs12 md11 mb-5>
                    <h3><b>Mortes no transporte</b></h3>
                </v-flex>
            </v-layout>
            <v-layout row class="ma-0 px-2">
                <v-flex xs12 sm12 md6 lg6 xl6>
                  <v-layout row class="ma-0 px-4">
                    <v-flex class="item" xs12 md11 mb-5>
                      <span class="body-1">Machos</span>
                    </v-flex>
                  </v-layout>
                  <v-layout row class="ma-0 px-4">
                    <v-flex xs12 class="pa-1">
                      <v-text-field
                        label="Quantidade de animais"
                        outlined
                        v-model="qtdMortesTransporteMachos"
                        :filled="sgSexoLote === 'FE'"
                        :readonly="sgSexoLote === 'FE'"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm12 md6 lg6 xl6>
                  <v-layout row class="ma-0 px-4">
                    <v-flex class="item" xs12 md11 mb-5>
                      <span class="body-1">Fêmeas</span>
                    </v-flex>
                  </v-layout>
                  <v-layout row class="ma-0 px-4">
                    <v-flex xs12 class="pa-1">
                      <v-text-field
                        label="Quantidade de animais"
                        outlined
                        v-model="qtdMortesTransporteFemeas"
                        :filled="sgSexoLote === 'MA'"
                        :readonly="sgSexoLote === 'MA'"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
            </v-layout>
        </v-form>
        <v-layout pa-2 pr-8 pl-8>
            <v-flex>
                <AppMainActionsButtonsForm @save="saveRegistro" @return="voltar" :canDelete="false"/>
            </v-flex>
        </v-layout>
    </AppMainFormCard>
</template>

<script>
import { campoObrigatorio, campoSelectObrigatorio, validarData, validarHora, validarDataFutura, campoMaiorZero, tamanhoMaximoOito } from '@/filters/rules'
import { MensagemSuccessSave } from '@/resourceMessageFile.js'
import { uepTypeExpand, dateLocalToIso, dateIsoToLocal } from '@/filters/utils'

import AppMainFormCard from '@/components/layout/AppMainFormCard.vue'
import AppMainActionsButtonsForm from '@/components/layout/AppMainActionsButtonsForm.vue'
import SelectDate from '@/components/general/SelectDate.vue'
import SelectHour from '@/components/general/SelectHour.vue'
import { mask } from 'vue-the-mask'

const toUepsView = entry => {
    let displayName = entry.nrUnidadeExploracao + ' - ' + uepTypeExpand(entry.csTipoUnidadeExploracao)
    return {...entry, displayName}
}


const DIVERGENCE_TYPES = {
  CMA: "CMA",
  CME: "CME",
  MTR: "MTR"
}

const DIVERGENCE_TYPES_TO_ITEMS = [{
  text: "Carregado a mais",
  value: DIVERGENCE_TYPES.CMA
}, {
  text: "Carregado a menos",
  value: DIVERGENCE_TYPES.CME
}]

const MODEL_PEDIDO = {

}

export default {
    name: 'EntradaAnimais',
    components: {
        AppMainFormCard,
        AppMainActionsButtonsForm,
        SelectDate,
        SelectHour,
    },
    directives: {
        mask,
    },
    data() {
        return{
            isFormValid: false,
            isEditing: false,
            isModified: false,
            registro: {},
            isLoading: false,
            cdLoteProducao: 0,
            dataGta: '',
            dataEntrada: '',
            unidadesExploracao: [],
            listaSaidasDisponiveis: [],
            cdSaidaAnimaisSelecionada: 0,
            saidaSelecionada: false,
            nmEstabelecimento: '',
            dsUnidadeExploracao: '',
            maskSerie: 'AA',
            maskGta: '#########',
            maskQtAnimais: '#########',

            idDivergenciaCarregamentoMachos: null,
            tipoDivergenciaMachos: null,
            qtdDivergenciaMachos: 0,

            idDivergenciaCarregamentoFemeas: null,
            tipoDivergenciaFemeas: null,
            qtdDivergenciaFemeas: 0,

            idMortesTransportesMachos: null,
            qtdMortesTransporteMachos: 0,

            idMortesTransportesFemeas: null,
            qtdMortesTransporteFemeas: 0,
            sgSexoLote: 'MI',
            loteProducao: null
        }
    },
    computed: {
        tituloTela: {
            get() {
                if (this.isEditing)
                    return 'Alojamento: ' + this.registro.idEntradaAnimais

                return 'Inserindo novo Alojamento'
            }
        },
        estabelecimentos () {
            return this.$store.state.estabelecimentos
        },
        lotesProducao () {
            return this.$store.state.lotesProducao
        },
        urlAPIEstabelecimento() {
            return this.$store.state.urlAPIEstabelecimento
        },
        divergenceTypes() {
          return DIVERGENCE_TYPES_TO_ITEMS
        },
        qtAnimais() {
          if (!this.registro.qtMachos && !this.registro.qtFemeas) return this.registro.qtAnimais
          const qtMachos = parseInt(this.registro.qtMachos) || 0
          const qtFemeas = parseInt(this.registro.qtFemeas) || 0
          return qtMachos + qtFemeas
        },
        regraCampoObrigatorioMacho() {
                return this.sgSexoLote === 'MA' ? [this.campoObrigatorio] : []
        },
        regraCampoObrigatorioFemea() {
                return this.sgSexoLote === 'FE' ? [this.campoObrigatorio] : []
        }
    },
    methods: {
        campoObrigatorio,
        campoSelectObrigatorio,
        validarData,
        validarHora,
        validarDataFutura,
        campoMaiorZero,
        dateLocalToIso,
        dateIsoToLocal,
        tamanhoMaximoOito,
        uepTypeExpand,
        calculaPeso(campo) {
            if (this.qtAnimais != 0)
            {
                if (campo == 'nrPesoMedio')
                {
                    this.registro.nrPesoTotal = this.calculaPesoTotal(this.registro.nrPesoMedio, this.qtAnimais)
                }
                else if (campo == 'nrPesoTotal')
                {
                    this.registro.nrPesoMedio = this.calculaPesoMedio(this.registro.nrPesoTotal, this.qtAnimais)
                }
                else
                {
                    if (this.registro.nrPesoMedio != '')
                    {
                        this.registro.nrPesoTotal = this.calculaPesoTotal(this.registro.nrPesoMedio, this.qtAnimais)
                    }
                    else if (this.registro.nrPesoTotal != '')
                    {
                        this.registro.nrPesoMedio = this.calculaPesoMedio(this.registro.nrPesoTotal, this.qtAnimais)
                    }
                    else
                    {
                        this.registro.nrPesoTotal = ''
                        this.registro.nrPesoMedio = ''
                    }
                }
            }
        },
        calculaPesoMedio(pesoTotal, totalAnimais) {
            if (pesoTotal != null)
            {
                if(pesoTotal.toString().includes(','))
                {
                    pesoTotal = pesoTotal.replace(',', '.')
                    this.registro.nrPesoTotal = pesoTotal
                }
                return (pesoTotal / totalAnimais).toFixed(2).toString()
            }
            else
            {
                return ''
            }
        },
        calculaPesoTotal(pesoMedio, totalAnimais) {
            if (pesoMedio.toString().includes(','))
            {
                pesoMedio = pesoMedio.replace(',', '.')
                this.registro.nrPesoMedio = pesoMedio
            }
            return Math.round(pesoMedio * totalAnimais)
        },
        getSaida(idSaida) {
            this.$axios.get('saida-animais/'+idSaida)
            .then((response) => {
                var rec = response.data[0].data
                rec.loteProducao = this.lotesProducao.find(i => i.idLoteProducao == rec.cdLoteProducao)
                this.registro.cdEstabelecimentoOrigem = rec.loteProducao.jsonEstabelecimento.idEstabelecimento
                this.registro.cdUnidadeExploracaoOrigem = rec.loteProducao.jsonUnidadeExploracao.idUnidadeExploracao
                this.nmEstabelecimento = rec.loteProducao.jsonEstabelecimento.nmEstabelecimento
                this.dsUnidadeExploracao = rec.loteProducao.jsonUnidadeExploracao.nrUnidadeExploracao + ' - ' + uepTypeExpand(rec.loteProducao.jsonUnidadeExploracao.csTipoUnidadeExploracao)
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        loadSaidasDisponiveis (cdLoteProducao) {
            var context = this
            this.$axios.get('lote-producao/'+cdLoteProducao+'/saidas-disponiveis/')
            .then((response) => {
                context.listaSaidasDisponiveis = []
                if (response.data[0].data != null)
                {
                    response.data[0].data.forEach(saida => {
                        context.listaSaidasDisponiveis.push(saida)
                    })
                }
                if (context.cdSaidaAnimaisSelecionada == null)
                    context.cdSaidaAnimaisSelecionada = 0
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        changeSaida(idSaida) {
            this.cdSaidaAnimaisSelecionada = idSaida
            this.saidaSelecionada = this.cdSaidaAnimaisSelecionada != 0
        },
        changeViewState(status, value) {
            if (status == 'isInserting'){
                this.isLoading = true
                if (this.$refs.form != undefined)
                {
                    this.$refs.form.reset()
                }
                this.carregarRegistrosLimpos()
                this.isLoading = false
                this.isEditing = false
                this.isModified = false
            } else if (status == 'isEditing'){
                this.isLoading = true
                this.getRegistro(value)
                this.isEditing = true
            } else if (status == 'isError'){
                this.$store.commit('setSnack', {type: 'error', msg : value})
                this.isLoading = false
            } else if (status == 'endLoading'){
                this.isLoading = false
            } else if (status == 'isLoading'){
                this.isLoading = true
            }
        },
        initViewFromRoute(route) {
            this.$store.dispatch('actLoadLotesProducao')
            this.$store.dispatch('actLoadEstabelecimentos')
            this.cdLoteProducao = parseInt(route.params.idLote)
            if (route.params.id){
                this.changeViewState('isEditing', route.params.id)
            } else {
                this.changeViewState('isInserting', null)
            }
            this.loadLoteProducao()
        },
        getRegistro (id) {
            this.$axios.get('entrada-animais/' + id + '/get-with-divergences/')
            .then((response) => {
                var rec = response.data[0].data
                rec.nrPesoMedio = this.calculaPesoMedio(rec.nrPesoTotal, rec.qtAnimais)
                this.registro = Object.assign({}, rec)
                this.dataBaixa = this.dateIsoToLocal(rec.dtBaixa)
                this.dataGta = this.dateIsoToLocal(rec.dtGta)
                this.dataEntrada = this.dateIsoToLocal(rec.dtEntrada)
                this.loadSaidasDisponiveis(this.cdLoteProducao)
                if(rec.cdSaidaAnimais != null)
                {
                    this.getSaida(rec.cdSaidaAnimais)
                    this.cdSaidaAnimaisSelecionada = rec.cdSaidaAnimais
                }

                const divergencias = rec["divergencias"]

                this.idDivergenciaCarregamentoMachos = divergencias["carregamento"]["machos"]["id_divergencia_entrada_animais"]
                this.tipoDivergenciaMachos = divergencias["carregamento"]["machos"]["cs_tipo_divergencia"]
                this.qtdDivergenciaMachos = divergencias["carregamento"]["machos"]["qt_animais"]

                this.idDivergenciaCarregamentoFemeas = divergencias["carregamento"]["femeas"]["id_divergencia_entrada_animais"]
                this.tipoDivergenciaFemeas = divergencias["carregamento"]["femeas"]["cs_tipo_divergencia"]
                this.qtdDivergenciaFemeas = divergencias["carregamento"]["femeas"]["qt_animais"]

                this.idMortesTransportesMachos = divergencias["mortes"]["machos"]["id_divergencia_entrada_animais"]
                this.qtdMortesTransporteMachos = divergencias["mortes"]["machos"]["qt_animais"]

                this.idMortesTransportesFemeas = divergencias["mortes"]["femeas"]["id_divergencia_entrada_animais"]
                this.qtdMortesTransporteFemeas = divergencias["mortes"]["femeas"]["qt_animais"]


                this.changeViewState('endLoading')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        saveRegistro() {
            if (this.$refs.form.validate())
            {
                if (this.isEditing)
                {
                    this.updateRegistro()
                }
                else
                {
                    this.insertRegistro()
                }
            }
        },
        insertRegistro () {
            this.changeViewState('isLoading')
            this.registro.hrEntrada = this.registro.hrEntrada != '' ? this.registro.hrEntrada + ':00' : null
            this.registro.dtEntrada = this.dateLocalToIso(this.dataEntrada)
            this.registro.nrPesoTotal = this.registro.nrPesoTotal != '' ? this.registro.nrPesoTotal : 0
            if (this.cdSaidaAnimaisSelecionada == 0)
            {
                this.registro.cdSaidaAnimais = null
                this.registro.dtGta = this.dateLocalToIso(this.dataGta)
                this.registro.qtAnimaisSaida = this.qtAnimais
            }
            else
            {
                var saidaAnimais = this.listaSaidasDisponiveis.find(i => i.idSaidaAnimais == this.cdSaidaAnimaisSelecionada)
                this.registro.cdSaidaAnimais = this.cdSaidaAnimaisSelecionada
                this.registro.dtGta = this.dateLocalToIso(saidaAnimais.dtGta)
                this.registro.nrGta = saidaAnimais.nrGta
                this.registro.dsSerieGta = saidaAnimais.dsSerieGta
                this.registro.qtAnimaisSaida = saidaAnimais.qtAnimais
                this.registro.dsPlacaCaminhao = saidaAnimais.dsPlacaCaminhao
                this.registro.cdEstabelecimentoOrigem = saidaAnimais.loteProducao.jsonEstabelecimento.idEstabelecimento
                this.registro.cdUnidadeExploracaoOrigem = saidaAnimais.loteProducao.cdUnidadeExploracao
            }
            if (this.registro.dtEntrada >= this.registro.dtGta)
            {
                this.$axios.post('entrada-animais/', this.registro)
                .then((response) => {
                    const rec = response.data[0].data
                    this.registro.idEntradaAnimais = rec.idEntradaAnimais
                    this.updateInsertDivergencias()
                })
                .catch((error) => {
                    this.changeViewState('isError', error)
                })
            }
            else
            {
                this.changeViewState('isError', 'Não é possível cadastrar um alojamento com a data do GTA superior a data de alojamento.')
            }
        },
        async updateInsertDivergencias() {
          await this.updateInsertDivergenciaCarregamentoMachos()
          await this.updateInsertDivergenciaCarregamentoFemeas()
          await this.updateInsertMorteTransporteMachos()
          await this.updateInsertMorteTransporteFemeas()
          this.$router.go(-1)
          this.$store.commit('setSnack', {type: 'success', msg: MensagemSuccessSave})
        this.changeViewState('endLoading')
        },
        async updateInsertDivergenciaCarregamentoMachos() {
          if (!this.tipoDivergenciaMachos || !this.qtdDivergenciaMachos) return
          const payload = {
            cd_lote_producao: this.cdLoteProducao,
            cs_tipo_divergencia: this.tipoDivergenciaMachos,
            cd_entrada_animais: this.registro.idEntradaAnimais,
            qt_animais: this.qtdDivergenciaMachos,
            sg_sexo: "MA"
          }
          if (this.idDivergenciaCarregamentoMachos) {
            await this.$axios.put("divergencia-entrada-animais/" + this.idDivergenciaCarregamentoMachos, payload)
                .finally(() => {
                    return
                })
          } else {
            await this.$axios.post("divergencia-entrada-animais/", payload)
                .finally(() => {
                    return
                })
          }
        },
        async updateInsertDivergenciaCarregamentoFemeas() {
          if (!this.tipoDivergenciaFemeas || !this.qtdDivergenciaFemeas) return
          const payload = {
            cd_lote_producao: this.cdLoteProducao,
            cs_tipo_divergencia: this.tipoDivergenciaFemeas,
            cd_entrada_animais: this.registro.idEntradaAnimais,
            qt_animais: this.qtdDivergenciaFemeas,
            sg_sexo: "FE"
          }
          if (this.idDivergenciaCarregamentoFemeas) {
            await this.$axios.put("divergencia-entrada-animais/" + this.idDivergenciaCarregamentoFemeas, payload)
                .finally(() => {
                    return
                })
          } else {
            await this.$axios.post("divergencia-entrada-animais/", payload)
                .finally(() => {
                    return
                })
          }
        },
        async updateInsertMorteTransporteMachos() {
          if (!this.qtdMortesTransporteMachos) return
          const payload = {
            cd_lote_producao: this.cdLoteProducao,
            cs_tipo_divergencia: DIVERGENCE_TYPES.MTR,
            cd_entrada_animais: this.registro.idEntradaAnimais,
            qt_animais: this.qtdMortesTransporteMachos,
            sg_sexo: "MA"
          }
          if (this.idMortesTransportesMachos) {
            await this.$axios.put("divergencia-entrada-animais/" + this.idMortesTransportesMachos, payload)
                .finally(() => {
                    return
                })
          } else {
            await this.$axios.post("divergencia-entrada-animais/", payload)
                .finally(() => {
                    return
                })
          }
        },
        async updateInsertMorteTransporteFemeas() {
          if (!this.qtdMortesTransporteFemeas) return
          const payload = {
            cd_lote_producao: this.cdLoteProducao,
            cs_tipo_divergencia: DIVERGENCE_TYPES.MTR,
            cd_entrada_animais: this.registro.idEntradaAnimais,
            qt_animais: this.qtdMortesTransporteFemeas,
            sg_sexo: "FE"
          }
           if (this.idMortesTransportesFemeas) {
            await this.$axios.put("divergencia-entrada-animais/" + this.idMortesTransportesFemeas, payload)
                .finally(() => {
                    return
                })
          } else {
             await this.$axios.post("divergencia-entrada-animais/", payload)
                .finally(() => {
                    return
                })
          }
        },
        updateRegistro() {
            this.changeViewState('isLoading')
            this.registro.hrEntrada = this.registro.hrEntrada != '' ? this.registro.hrEntrada + ':00' : null
            this.registro.dtEntrada = this.dateLocalToIso(this.dataEntrada)
            this.registro.dtGta = this.dateLocalToIso(this.dataGta)
            this.registro.qtAnimaisSaida = this.qtAnimais
            this.registro.nrPesoTotal = this.registro.nrPesoTotal != '' ? this.registro.nrPesoTotal : 0
            if (this.registro.dtEntrada >= this.registro.dtGta)
            {
                this.$axios.put('entrada-animais/' + this.registro.idEntradaAnimais, this.registro)
                .then(() => {
                    this.$store.commit('setSnack', {type: 'success', msg: MensagemSuccessSave})
                    this.changeViewState('endLoading')
                    this.updateInsertDivergencias()
                })
                .catch((error) => {
                    this.changeViewState('isError', error)
                })
            }
            else
            {
                this.changeViewState('isError', 'Não é possível cadastrar um alojamento com a data do GTA superior a data de alojamento.')
            }
        },
        beforeDeleteRegistro() {
            this.$root.$confirm('Deseja Excluir?', 'O registro será excluído permanentemente.', { color: 'red', width: 400 })
            .then(confirm => {
                if (confirm)
                    this.deleteRegistro()
            })
        },
        deleteRegistro() {
            this.changeViewState('isLoading')
            this.$axios.delete('entrada-animais/' + this.registro.idEntradaAnimais)
            .then(() => {
                this.$router.go(-1)
                this.changeViewState('endLoading')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        carregarRegistrosLimpos() {
            this.registro = {
                idEntradaAnimais: '',
                cdEstabelecimentoOrigem: null,
                cdUnidadeExploracaoOrigem: null,
                nrGta: '',
                dsSerieGta: '',
                dtGta: null,
                dtEntrada: null,
                hrEntrada: null,
                qtMachos: 0,
                qtFemeas: 0,
                qtAnimais: 0,
                qtAnimaisSaida: 0,
                dsPlacaCaminhao: '',
                cdLoteProducao: this.cdLoteProducao,
                nrPesoMedio: 0,
                nrPesoTotal: 0,
                cdSaidaAnimais: 0,
            }
            this.sgSexoLote = ''

            this.loadSaidasDisponiveis(this.cdLoteProducao)
        },
        loadLoteProducao () {
            this.$axios.get('lote-producao/'+ this.$route.params.idLote)
            .then( response => {
                const batch = response.data[0].data

                this.sgSexoLote = batch.sgSexo
            })
        },
        voltar() {
            this.$router.go(-1)
        }
    },
    watch: {
        '$route' (to) {
            this.initViewFromRoute(to)
        },
        'registro.cdEstabelecimentoOrigem' (value) {
            if (!this.isLoading)
            {
                if (value != undefined)
                {
                    var context = this
                    this.$axios.get(this.urlAPIEstabelecimento + 'unidadeExploracao/?cdEstabelecimento=' + value)
                        .then((response) => {
                            var unidadesExploracao = response.data ? response.data.filter(entry => entry.stAtivo).map(toUepsView) : []
                            context.unidadesExploracao = unidadesExploracao
                        })
                        .catch((error) => {
                            this.changeViewState('isError', error)
                        })
                }
                else
                {
                    this.unidadesExploracao = []
                }
            }
        },
    },
    mounted() {
        this.initViewFromRoute(this.$route)
    },
}
</script>

<style scoped>
    .item {
        margin: 1px
    }
    .marginTitle {
        margin: 15px;
    }
    .headerCard {
        color: white; 
        background: #04222D; 
        padding:10px;
    }
    .colorOrange {
        background: #ff5429 !important;
    }
    .colorGray {
        background: #e8e8e8;
    }
</style>
